import { useState, useEffect } from 'react';

// Keep in sync with $bp-mobile in sass/_mobile.scss (768px).
export const MOBILE_BREAKPOINT_PX = 768;
const MOBILE_QUERY = `(max-width: ${MOBILE_BREAKPOINT_PX - 0.02}px)`;

const getMatches = () =>
	typeof window !== 'undefined' && typeof window.matchMedia === 'function'
		? window.matchMedia(MOBILE_QUERY).matches
		: false;

/** True while the viewport is phone-sized (< 768px). Updates on resize/rotate. */
const useIsMobile = () => {
	const [isMobile, setIsMobile] = useState(getMatches);

	useEffect(() => {
		if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return undefined;
		const mql = window.matchMedia(MOBILE_QUERY);
		const onChange = (e) => setIsMobile(e.matches);
		setIsMobile(mql.matches);
		mql.addEventListener('change', onChange);
		return () => mql.removeEventListener('change', onChange);
	}, []);

	return isMobile;
};

export default useIsMobile;
